__turbopack_context__.v({
  "arrow": "BlogCard-module-scss-module__vJRFyG__arrow",
  "blogArrow": "BlogCard-module-scss-module__vJRFyG__blogArrow",
  "bottom": "BlogCard-module-scss-module__vJRFyG__bottom",
  "clockIcon": "BlogCard-module-scss-module__vJRFyG__clockIcon",
  "content": "BlogCard-module-scss-module__vJRFyG__content",
  "gradient": "BlogCard-module-scss-module__vJRFyG__gradient",
  "heading": "BlogCard-module-scss-module__vJRFyG__heading",
  "root": "BlogCard-module-scss-module__vJRFyG__root",
  "strip": "BlogCard-module-scss-module__vJRFyG__strip",
  "text": "BlogCard-module-scss-module__vJRFyG__text",
});
